import React from 'react';

interface TranscriptIconProps {
  className?: string;
}

export function TranscriptIcon({ className = "w-4 h-4" }: TranscriptIconProps) {
  return (
    <div className={`relative ${className}`}>
      {/* Document shape */}
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14,2 14,8 20,8" />
      </svg>
      {/* tscrt overlay */}
      <span 
        className="absolute inset-0 flex items-center justify-center text-[5px] font-bold tracking-tighter"
        style={{ marginTop: '3px' }}
      >
        tscrt
      </span>
    </div>
  );
}
